<div *ngIf="images && images?.length > 0" class="carousel-container">
    @for (image of images; track $index; let i = $index) {
        @if (image.isIcon) {
            <i [ngClass]="{ 'image-active': selectedIndex === i }" class="material-icons">{{image.content}}</i>
        } @else if (isInlineImage(image.content)) {
            <img [src]="image.content" [alt]="" [ngClass]="{ 'image-active': selectedIndex === i }"/>
        } @else {
            @if (image.content | secureImg | async; as secureImage) {
                <img [src]="secureImage.url" [alt]="" [ngClass]="{ 'image-active': selectedIndex === i }"/>
            }
        }
    }

    <div *ngIf="indicators" class="carousel-dot-container">
    <span
            *ngFor="let dot of images; let i = index"
            class="dot"
            [ngClass]="{ active: selectedIndex === i }"
            (click)="selectImage(i, $event)"
    ></span>
    </div>
</div>
